import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './ProvidersPage.css';

// Import provider images
import SarahPehrsonImg from '../assets/providers/sarah pehrson photo.avif';
import TravisHicksImg from '../assets/providers/travis hicks photo.avif';
import JoyShearImg from '../assets/providers/joy shear photo.avif';
import TroyEdenImg from '../assets/providers/troy eden photo.avif';
import JacobPughImg from '../assets/providers/jacob pugh photo.avif';
import AliLostraImg from '../assets/providers/ali-marie lostra photo.avif';

const ProvidersPage = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="providers-container">
        <h1 className="providers-title">Our Providers</h1>
        <p className="providers-description">Meet our experienced team of board-certified healthcare professionals dedicated to your care.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-7xl mx-auto px-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                <img src={SarahPehrsonImg} alt="Sarah Pehrson" className="provider-img" />
              </div>
              <div className="provider-credential">APRN</div>
            </div>
            <div className="provider-content">
              <h3>Sarah Pehrson</h3>
              <div className="provider-hours">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon" style={{marginTop: '4px'}}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>8AM - 8PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Spring Creek</span>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Elko</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                <img src={TravisHicksImg} alt="Travis Hicks" className="provider-img" />
              </div>
              <div className="provider-credential">PA-C</div>
            </div>
            <div className="provider-content">
              <h3>Travis Hicks</h3>
              <div className="provider-hours">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon" style={{marginTop: '4px'}}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>8AM - 8PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Spring Creek</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                  <img src={JoyShearImg} alt="Joy Shear" className="provider-img" />
              </div>
              <div className="provider-credential">PA-C</div>
            </div>
            <div className="provider-content">
              <h3>Joy Shear</h3>
              <div className="provider-hours">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon" style={{marginTop: '4px'}}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>8AM - 8PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Spring Creek</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                  <img src={TroyEdenImg} alt="Troy Eden" className="provider-img" />
              </div>
              <div className="provider-credential">PA-C</div>
            </div>
            <div className="provider-content">
              <h3>Troy Eden</h3>
              <div className="provider-hours">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon" style={{marginTop: '4px'}}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>8AM - 8PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Elko</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                  <img src={JacobPughImg} alt="Jacob Pugh" className="provider-img" />
              </div>
              <div className="provider-credential">PA-C</div>
            </div>
            <div className="provider-content">
              <h3>Jacob Pugh</h3>
              <div className="provider-hours">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon" style={{marginTop: '4px'}}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>8AM - 8PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Elko</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="provider-card">
            <div className="provider-header">
              <div className="provider-image">
                  <img src={AliLostraImg} alt="Ali-Marie Lostra" className="provider-img" />
              </div>
              <div className="provider-credential">PA-C</div>
            </div>
            <div className="provider-content">
              <h3>Ali-Marie Lostra</h3>
              <div className="provider-hours">
                <span>9AM - 6PM</span>
              </div>
              <div className="location-container">
                <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-lg p-2 border-l-3 border-primary">
                  <div className="flex items-center space-x-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin" style={{marginTop: '4px'}}>
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="font-semibold text-secondary text-xs">Elko</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Locations Section */}
        <div className="locations-section mt-16">
          <h2 className="locations-title text-3xl font-bold mb-4">Our Locations</h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto" style={{marginBottom: "2rem", color: "#4b5563"}}>
            Two convenient locations serving the Elko County community with exceptional urgent care services
          </p>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Spring Creek Card */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="bg-gradient-to-br from-primary to-primary-dark p-5">
                <div className="flex items-center space-x-2.5 mb-1.5">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin text-white">
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white" style={{marginBottom: "0rem"}}>Spring Creek</h3>
                </div>
                <p className="text-white/90 text-xs ml-12">Your trusted urgent care partner</p>
              </div>
              <div className="p-5 space-y-3">
                <p className="text-gray-700 text-sm leading-relaxed">
                  Serving the Spring Creek community with quality health care services. Our experienced team is here to provide prompt, professional medical attention when you need it most.
                </p>
                <div className="space-y-2.5 pt-3 border-t border-gray-100" style={{borderTop: "0.75px solid #eaeaea"}}>
                  <div className="flex items-start space-x-2.5 mb-1" style={{marginBottom: "0.75rem"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-users mt-0.5 flex-shrink-0" style={{marginTop: 4}}>
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">3 Providers</p>
                      <p className="text-xs text-gray-600" style={{color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))'}}>Sarah Pehrson, Travis Hicks, Joy Shear</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5 mb-1" style={{marginBottom: "0.75rem"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock text-primary mt-0.5 flex-shrink-0" style={{marginTop: 4}}>
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">Daily Coverage</p>
                      <p className="text-xs text-gray-600" style={{color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))'}}>Open 7 days a week for your convenience</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5 mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone text-primary mt-0.5 flex-shrink-0" style={{marginTop: 4}}>
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">Walk-ins Welcome</p>
                      <p className="text-xs text-gray-600" style={{color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))'}}>No appointment necessary</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Elko Card */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="bg-gradient-to-br from-primary to-primary-dark p-5">
                <div className="flex items-center space-x-2.5 mb-1.5">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin text-white">
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white" style={{marginBottom: "0rem"}}>Elko</h3>
                </div>
                <p className="text-white/90 text-xs ml-12">Comprehensive care for your family</p>
              </div>
              <div className="p-5 space-y-3">
                <p className="text-gray-700 text-sm leading-relaxed">
                  Providing comprehensive health care to the Elko area. We're committed to delivering high-quality medical services with compassion and expertise for all your healthcare needs.
                </p>
                <div className="space-y-2.5 pt-3 border-t border-gray-100" style={{borderTop: "0.75px solid #eaeaea"}}>
                  <div className="flex items-start space-x-2.5 mb-1" style={{marginBottom: "0.75rem"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-users mt-0.5 flex-shrink-0" style={{marginTop: 4}}>
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">4 Providers</p>
                      <p className="text-xs text-gray-400" style={{color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))'}}>Sarah Pehrson, Troy Eden, Jacob Pugh, Ali Lostra</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5 mb-1" style={{marginBottom: "0.75rem"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock text-primary mt-0.5 flex-shrink-0" style={{marginTop: '4px'}}>
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">Daily Coverage</p>
                      <p className="text-xs text-gray-600" style={{color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))'}}>Available 7 days a week for your convenience</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5 mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone text-primary mt-0.5 flex-shrink-0" style={{marginTop: '4px'}}>
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <div>
                      <p className="font-semibold text-secondary text-sm">Walk-ins Welcome</p>
                      <p className="text-xs text-gray-600">No appointment necessary</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProvidersPage;
